import { render } from "./reportDishKDStime.vue?vue&type=template&id=261be186"
import script from "./reportDishKDStime.vue?vue&type=script&lang=js"
export * from "./reportDishKDStime.vue?vue&type=script&lang=js"

import "./reportDishKDStime.vue?vue&type=style&index=0&id=261be186&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__